//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const LogSensitiveData: FeatureFlag = {"Id":"LogSensitiveData","Label":"Write sensitive data to logs (not comprehensive)","Impact":"For Support/Debugging. Write sensitive data to logs.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
